import React from 'react'
import { sanitizeUrl } from '../../../global/formatters/sanitize-url.js'
import { isLocal } from '../../../spa/utility/index.js'

function AuthenticatedDropdownInvestor() {
  return (
    <li className="UtilityNavigation-listItem u-hidden u-sm-inlineBlock u-marginLeft3gu u-sm-marginLeft0">
      <a
        className="UtilityNavigation-action u-textSizeMsrp1 u-textNoWrap Button Button--secondary"
        href={sanitizeUrl(
          `${isLocal() ? '/cti-site/cti-investorspa' : '/investor'}/login`
        )}
      >
        Log In
      </a>
    </li>
  )
}

export default AuthenticatedDropdownInvestor
